export const handlePlanConversion = ({ planPrice }: { planPrice: number }) => {
  window.gtag("event", "plan_purchase_conversion", {
    send_to: "AW-11438798984/BV8RCNq1yv4YEIjxuM4q",
    value: planPrice,
    currency: "USD",
    transaction_id: "",
  });
};
